import React, { useState } from 'react'

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'

import './flowambassador.css'

const Flowambassador = (props) => {
  const [isVisible, setIsVisible] = useState(1)
  return (
    <div className={`flowambassador-container10 ${props.rootClassName} `}>
      {isVisible === 1 && (
        <div className="flowambassador-thq-content-elm">
          <div className="flowambassador-container11">
            <h1 className="flowambassador-thq-title-elm1">
              <span>Thank you</span>
              <br></br>
            </h1>
            <h1 className="flowambassador-thq-title-elm2">{props.title1}</h1>
            <img
              alt={props.imageAlt14}
              src={props.imageSrc1}
              className="flowambassador-image10"
            />
          </div>
          <div className="flowambassador-container12">
            <span className="flowambassador-thq-caption-elm1 one-liner">
              {props.caption3}
            </span>
            <span className="paragraph">{props.caption11}</span>
          </div>
          <div className="flowambassador-thq-buttons-elm10">
            <span
              onClick={() => setIsVisible(2)}
              className="flowambassador-text12 button"
            >
              {props.text}
            </span>
            <a href="#intro" className="flowambassador-link1">
              <div className="flowambassador-container13">
                <span className="flowambassador-text13">{props.text33}</span>
                <svg
                  viewBox="0 0 1024 1024"
                  className="icon flowambassador-icon10"
                >
                  <path d="M854 512l-342 342-342-342 62-60 238 238v-520h84v520l240-238z"></path>
                </svg>
                <div className="flowambassador-container14">
                  <div className="flowambassador-container15">
                    <Script
                      html={`<style>

.icon {
  width: 16px;
  height: 16px;
  animation: move-down1 1s ease-in infinite alternate-reverse;
  transition: all 0.2s;
}

@keyframes move-down1 {
  to {
    transform: translateY(5px);
  }
}

</style>`}
                    ></Script>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      )}
      {isVisible === 2 && (
        <div className="flow_card">
          <div className="flowambassador-thq-buttons-elm11">
            <div
              onClick={() => {
                setIsVisible(1)
                setIsVisible(1)
              }}
              className="flow_button"
            >
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador-container16">
            <div className="flowambassador-thq-header-elm1">
              <div className="flowambassador-container17">
                <div className="flowambassador-container18">
                  <span className="index_black">{props.section1}</span>
                  <div className="flowambassador-container19">
                    <span className="index_blue">{props.text1}</span>
                    <div className="flowambassador-thq-divider-elm1"></div>
                    <span className="index_black">{props.text2}</span>
                  </div>
                </div>
                <label className="flowambassador-thq-name-elm1 heading">
                  {props.name4}
                </label>
              </div>
              <p className="flowambassador-thq-caption-elm3 paragraph">
                {props.caption21}
              </p>
            </div>
            <div className="flowambassador-thq-buttons-elm12">
              <div
                onClick={() => setIsVisible(3)}
                className="flowambassador-thq-button-elm11 flow_button"
              >
                <span className="flowambassador-thq-text-elm10">
                  {props.text25}
                </span>
              </div>
              <div
                onClick={() => setIsVisible(8)}
                className="flowambassador-thq-button-elm12 flow_button"
              >
                <span className="flowambassador-thq-text-elm11">
                  {props.text110}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 3 && (
        <div className="flow_card">
          <div className="flowambassador-thq-buttons-elm13">
            <div onClick={() => setIsVisible(2)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador-container20">
            <div className="flowambassador-thq-header-elm2">
              <div className="flowambassador-container21">
                <span className="index_black">{props.section11}</span>
                <div className="flowambassador-container22">
                  <span className="index_blue">{props.text4}</span>
                  <div className="flowambassador-thq-divider-elm2"></div>
                  <span className="index_black">{props.text5}</span>
                </div>
              </div>
              <label className="flowambassador-thq-name-elm2 heading">
                {props.name11}
              </label>
            </div>
            <div className="flowambassador-container23">
              <div className="flowambassador-container24">
                <div>
                  <div className="flowambassador-container25">
                    <img
                      alt={props.imageAlt15}
                      src={props.imageSrc11}
                      className="flowambassador-image11"
                    />
                    <span className="flow_text">{props.text31}</span>
                  </div>
                </div>
                <div>
                  <div className="flowambassador-container26">
                    <img
                      alt={props.imageAlt21}
                      src={props.imageSrc21}
                      className="flowambassador-image12"
                    />
                    <span className="flow_text">{props.text41}</span>
                  </div>
                </div>
                <div>
                  <div className="flowambassador-container27">
                    <img
                      alt={props.imageAlt31}
                      src={props.imageSrc31}
                      className="flowambassador-image13"
                    />
                    <span className="flow_text">{props.text51}</span>
                  </div>
                </div>
                <div>
                  <div className="flowambassador-container28">
                    <img
                      alt={props.imageAlt41}
                      src={props.imageSrc41}
                      className="flowambassador-image14"
                    />
                    <div className="flowambassador-container29">
                      <span className="flow_text">{props.text61}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flowambassador-container30">
                    <img
                      alt={props.imageAlt51}
                      src={props.imageSrc51}
                      className="flowambassador-image15"
                    />
                    <div className="flowambassador-container31">
                      <span className="flow_text">{props.text71}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flowambassador-thq-buttons-elm14">
              <a href="#ambassador" className="flowambassador-link2">
                <p className="flowambassador-thq-caption-elm4 paragraph">
                  <span>
                    <span>{props.text6}</span>
                    <span>{props.text7}</span>
                  </span>
                  <span className="flowambassador-text21">{props.text3}</span>
                </p>
              </a>
              <div
                onClick={() => setIsVisible(4)}
                className="flowambassador-thq-button-elm15 flow_button"
              >
                <span className="flowambassador-thq-text-elm17">
                  {props.text26}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 4 && (
        <div className="flow_card">
          <div className="flowambassador-thq-buttons-elm15">
            <div onClick={() => setIsVisible(3)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador-container32">
            <div className="flowambassador-thq-header-elm3">
              <div className="flowambassador-container33">
                <div className="flowambassador-container34">
                  <span className="index_black">{props.section21}</span>
                  <div className="flowambassador-container35">
                    <span className="index_blue">{props.text13}</span>
                    <div className="flowambassador-thq-divider-elm3"></div>
                    <span className="index_black">{props.text14}</span>
                  </div>
                </div>
                <label className="flowambassador-thq-name-elm3 heading">
                  {props.name21}
                </label>
              </div>
            </div>
            <div className="flowambassador-container36">
              <p className="flowambassador-thq-caption-elm5 paragraph">
                <span>{props.text8}</span>
                <a href="#brand" className="flowambassador-link3">
                  {props.text9}
                </a>
              </p>
              <p className="flowambassador-thq-caption-elm6 paragraph">
                {props.caption21112}
              </p>
            </div>
            <div className="flowambassador-thq-field-elm15">
              <div className="flowambassador-container37">
                <img
                  alt={props.imageAlt61}
                  src={props.imageSrc61}
                  className="flowambassador-image16 flow_image"
                />
                <span className="flow_text2">
                  <span>{props.text37}</span>
                  <span className="flowambassador-text26">{props.text38}</span>
                  <span className="flowambassador-text27">{props.text39}</span>
                </span>
              </div>
            </div>
            <div className="flowambassador-thq-buttons-elm16">
              <p className="flowambassador-thq-caption-elm7 paragraph">
                <span>{props.text10}</span>
                <a href="#strategy" className="flowambassador-link4">
                  {props.text29}
                </a>
              </p>
              <div
                onClick={() => setIsVisible(5)}
                className="flowambassador-thq-button-elm18 flow_button"
              >
                <span className="flowambassador-thq-text-elm19">
                  {props.text81}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 5 && (
        <div className="flow_card">
          <div className="flowambassador-thq-buttons-elm17">
            <div onClick={() => setIsVisible(4)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador-container38">
            <div className="flowambassador-thq-header-elm4">
              <div className="flowambassador-container39">
                <span className="index_black">{props.section31}</span>
                <div className="flowambassador-container40">
                  <span className="index_blue">{props.text15}</span>
                  <div className="flowambassador-thq-divider-elm4"></div>
                  <span className="index_black">{props.text16}</span>
                </div>
              </div>
              <label className="flowambassador-thq-name-elm4 heading">
                {props.name31}
              </label>
            </div>
            <div className="flowambassador-thq-field-elm16">
              <div className="flowambassador-container41">
                <img
                  alt={props.imageAlt71}
                  src={props.imageSrc71}
                  className="flowambassador-image17 flow_image"
                />
                <div className="flowambassador-container42">
                  <span className="flow_text2">{props.text101}</span>
                  <div className="flowambassador-container43">
                    <img
                      alt={props.imageAlt81}
                      src={props.imageSrc81}
                      className="flowambassador-image18"
                    />
                    <span className="flow_text">{props.text111}</span>
                  </div>
                  <div className="flowambassador-container44">
                    <img
                      alt={props.imageAlt91}
                      src={props.imageSrc91}
                      className="flowambassador-image19"
                    />
                    <span className="flow_text">{props.text12}</span>
                  </div>
                  <div className="flowambassador-container45">
                    <img
                      alt={props.imageAlt912}
                      src={props.imageSrc912}
                      className="flowambassador-image20"
                    />
                    <span className="flow_text">{props.text122}</span>
                  </div>
                  <div className="flowambassador-container46">
                    <img
                      alt={props.imageAlt9111}
                      src={props.imageSrc9111}
                      className="flowambassador-image21"
                    />
                    <span className="flow_text">{props.text12111}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flowambassador-thq-buttons-elm18">
              <div
                onClick={() => setIsVisible(6)}
                className="flowambassador-thq-button-elm21 flow_button"
              >
                <span className="flowambassador-thq-text-elm25">
                  {props.text91}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 6 && (
        <div className="flow_card">
          <div className="flowambassador-thq-buttons-elm19">
            <div onClick={() => setIsVisible(5)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador-container47">
            <div className="flowambassador-thq-header-elm5">
              <div className="flowambassador-container48">
                <span className="index_black">{props.section51}</span>
                <div className="flowambassador-container49">
                  <span className="index_blue">{props.text19}</span>
                  <div className="flowambassador-thq-divider-elm5"></div>
                  <span className="index_black">{props.text20}</span>
                </div>
              </div>
              <label className="flowambassador-thq-name-elm5 heading">
                {props.name51}
              </label>
            </div>
            <div className="flowambassador-thq-field-elm17">
              <div className="flowambassador-container50">
                <img
                  alt={props.imageAlt131}
                  src={props.imageSrc131}
                  className="flowambassador-image22 flow_image"
                />
                <div className="flowambassador-container51">
                  <span className="flow_text2">{props.text18}</span>
                  <div className="flowambassador-container52">
                    <img
                      alt={props.imageAlt141}
                      src={props.imageSrc141}
                      className="flowambassador-image23"
                    />
                    <span className="flow_text">{props.text191}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flowambassador-thq-buttons-elm20">
              <div
                onClick={() => setIsVisible(7)}
                className="flowambassador-thq-button-elm24 flow_button"
              >
                <span className="flowambassador-thq-text-elm28">
                  {props.text17}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 7 && (
        <div className="flow_card">
          <div className="flowambassador-thq-buttons-elm21">
            <div onClick={() => setIsVisible(6)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador-container53">
            <div className="flowambassador-thq-header-elm6">
              <div className="flowambassador-container54">
                <span className="index_black">{props.section61}</span>
                <div className="flowambassador-container55">
                  <span className="index_blue">{props.text21}</span>
                  <div className="flowambassador-thq-divider-elm6"></div>
                  <span className="index_black">{props.text22}</span>
                </div>
              </div>
              <label className="flowambassador-thq-name-elm6 heading">
                {props.name61}
              </label>
            </div>
            <div className="flowambassador-thq-field-elm18">
              <div className="flowambassador-container56">
                <img
                  alt={props.imageAlt151}
                  src={props.imageSrc151}
                  className="flowambassador-image24 flow_image"
                />
                <div className="flowambassador-container57">
                  <span className="flow_text2">{props.text211}</span>
                  <div className="flowambassador-container58">
                    <img
                      alt={props.imageAlt161}
                      src={props.imageSrc161}
                      className="flowambassador-image25"
                    />
                    <span className="flow_text">{props.text221}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flowambassador-thq-buttons-elm22">
              <div
                onClick={() => setIsVisible(8)}
                className="flowambassador-thq-button-elm27 flow_button"
              >
                <span className="flowambassador-thq-text-elm31">
                  {props.text201}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 8 && (
        <div className="flow_card">
          <div className="flowambassador-thq-buttons-elm23">
            <div onClick={() => setIsVisible(7)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador-container59">
            <div className="flowambassador-thq-header-elm7">
              <div className="flowambassador-container60">
                <span className="index_black">{props.section7}</span>
                <div className="flowambassador-container61">
                  <span className="index_blue">{props.text23}</span>
                  <div className="flowambassador-thq-divider-elm7"></div>
                  <span className="index_black">{props.text24}</span>
                </div>
              </div>
              <label className="flowambassador-thq-name-elm7 heading">
                {props.name71}
              </label>
            </div>
            <div className="flowambassador-container62">
              <a
                href="https://www.instagram.com/romania/"
                target="_blank"
                rel="noreferrer noopener"
                className="flowambassador-link5"
              >
                <div className="flowambassador-thq-field-elm19 ambassador_contact">
                  <div className="flowambassador-container63">
                    <img
                      alt={props.imageAlt101}
                      src={props.imageSrc111}
                      className="flowambassador-image26"
                    />
                    <div className="flowambassador-container64">
                      <span className="flowambassador-thq-text-elm32 flow_text">
                        {props.text2211}
                      </span>
                      <span className="flowambassador-thq-text-elm33 flow_text">
                        {props.text2213321}
                      </span>
                    </div>
                  </div>
                  <img
                    alt={props.imageAlt111}
                    src={props.imageSrc121}
                    className="flowambassador-image27"
                  />
                  <img
                    alt={props.imageAlt125}
                    src={props.imageSrc171}
                    className="flowambassador-image28"
                  />
                  <img
                    alt={props.imageAlt1223}
                    src={props.imageSrc1721}
                    className="flowambassador-image29"
                  />
                  <img
                    alt={props.imageAlt1213}
                    src={props.imageSrc1712}
                    className="flowambassador-image30"
                  />
                  <img
                    alt={props.imageAlt173}
                    src={props.imageSrc182}
                    className="flowambassador-image31"
                  />
                </div>
              </a>
              <a
                href="mailto:hi@romania.org.ro?subject=Hi @Romania!"
                className="flowambassador-link6"
              >
                <div className="flowambassador-thq-field-elm20 ambassador_contact">
                  <div className="flowambassador-container65">
                    <img
                      alt={props.imageAlt1021}
                      src={props.imageSrc1121}
                      className="flowambassador-image32"
                    />
                    <div className="flowambassador-container66">
                      <span className="flowambassador-thq-text-elm34 flow_text">
                        {props.text221322}
                      </span>
                      <span className="flowambassador-thq-text-elm35 flow_text">
                        {props.text221333}
                      </span>
                    </div>
                  </div>
                  <img
                    alt={props.imageAlt12211}
                    src={props.imageSrc17211}
                    className="flowambassador-image33"
                  />
                  <img
                    alt={props.imageAlt1231}
                    src={props.imageSrc1731}
                    className="flowambassador-image34"
                  />
                  <img
                    alt={props.imageAlt12111}
                    src={props.imageSrc17111}
                    className="flowambassador-image35"
                  />
                  <img
                    alt={props.imageAlt1711}
                    src={props.imageSrc1811}
                    className="flowambassador-image36"
                  />
                </div>
              </a>
              <a href="tel:+40750453880" className="flowambassador-link7">
                <div className="flowambassador-thq-field-elm21 ambassador_contact">
                  <div className="flowambassador-container67">
                    <img
                      alt={props.imageAlt10221}
                      src={props.imageSrc11221}
                      className="flowambassador-image37"
                    />
                    <div className="flowambassador-container68">
                      <span className="flowambassador-thq-text-elm36 flow_text">
                        {props.text221321}
                      </span>
                      <span className="flowambassador-thq-text-elm37 flow_text">
                        {props.text221331}
                      </span>
                    </div>
                  </div>
                  <img
                    alt={props.imageAlt111121}
                    src={props.imageSrc121121}
                    className="flowambassador-image38"
                  />
                  <img
                    alt={props.imageAlt12221}
                    src={props.imageSrc17221}
                    className="flowambassador-image39"
                  />
                  <img
                    alt={props.imageAlt1241}
                    src={props.imageSrc1741}
                    className="flowambassador-image40"
                  />
                  <img
                    alt={props.imageAlt12121}
                    src={props.imageSrc17121}
                    className="flowambassador-image41"
                  />
                  <img
                    alt={props.imageAlt1721}
                    src={props.imageSrc1821}
                    className="flowambassador-image42"
                  />
                </div>
              </a>
            </div>
            <div className="flowambassador-thq-buttons-elm24">
              <div
                onClick={() => setIsVisible(1)}
                className="flowambassador-thq-button-elm30 flow_button"
              >
                <span className="flowambassador-thq-text-elm38">
                  {props.text231}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

Flowambassador.defaultProps = {
  imageAlt141: 'image',
  imageSrc17121: '/frames/corner.svg',
  imageAlt912: 'image',
  imageSrc1821: '/frames/corner_arrow.svg',
  section7: 'Ambassadors Program',
  text17: 'Continue ->',
  text2211: '@romania',
  text3: 'here.',
  imageSrc1712: '/frames/corner.svg',
  caption21112:
    "As a non-profit, we are building value for Romania by lifting its tourism industry. Contributing to our initiative means you help boost our country's economy and you have a positive impact on Romania's tourism promotion.",
  text122:
    'Donating for yourself means you become an Ambassador and you receive all the benefits associated.',
  section31: 'Ambassadors Program',
  name31: 'Decide who becomes an Ambassador',
  name11: 'What you get',
  imageAlt111121: 'image',
  text12:
    'You need to donate €5,000 or more for each person you wish to honor as an Ambassador.',
  imageSrc111: '/assets/ig_blue%20copy-200w.png',
  imageAlt14: 'image',
  section61: 'Ambassadors Program',
  imageAlt51: 'image',
  imageSrc61: '/external/roi_blue.svg',
  text14: '07',
  imageSrc81: '/frames/frame_shape2.svg',
  imageAlt10221: 'image',
  imageSrc912: '/frames/frame_shape2.svg',
  text6: 'See the complete description of your rewards ',
  imageAlt9111: 'image',
  imageAlt71: 'image',
  text8:
    'Our mission is to empower Romania via a Country Brand, Media Engine, Tourism and Tourism Promotion platforms and much more. Read all about it ',
  text19: '05',
  imageSrc161: '/frames/frame_shape2.svg',
  text221321: '+40 750 453 880',
  text23: '07',
  text9: 'here.',
  text: "I don't need convincing",
  text51: 'Name on an important monument',
  imageSrc21: '/formula/roi_blue2.svg',
  text231: 'Done',
  text18: 'Donate as a private person, company or non-profit',
  imageAlt151: 'image',
  imageAlt15: 'image',
  imageAlt61: 'image',
  text221331: 'call us',
  text41: 'Name  on the @Romania platform',
  imageSrc171: '/frames/corner.svg',
  imageAlt125: 'image',
  imageSrc1731: '/frames/corner.svg',
  text71: 'Elite networking opportunities and experiences',
  imageAlt1213: 'image',
  text3221: 'instagram.com/romania',
  imageAlt1021: 'image',
  imageSrc182: '/frames/corner_arrow.svg',
  name51: 'Enjoy flexibility in how you contribute',
  imageAlt1223: 'image',
  imageSrc71: '/external/roi_blue.svg',
  imageAlt81: 'image',
  imageAlt173: 'image',
  text22: '07',
  text81: 'Continue ->',
  text4: '02',
  text29: 'here.',
  text38: '€5,000 or more',
  imageSrc1741: '/frames/corner.svg',
  imageAlt31: 'image',
  imageSrc151: '/external/roi_blue.svg',
  imageSrc31: '/formula/roi_blue2.svg',
  name71: 'Get in touch to start your Ambassador journey',
  imageAlt12211: 'image',
  text20: '07',
  caption3:
    'If you are willing to join our initiative to do more and contribute €5,000, together we’ll put Romania back on the map.',
  text61: 'Bespoke medal crafted by the State Mint',
  text2111: 'text us',
  imageAlt12221: 'image',
  imageAlt1231: 'image',
  text13: '03',
  imageSrc17111: '/frames/corner.svg',
  caption11:
    'Stay awhile and learn how we’re going to do it, how you can become an Ambassador and what you get as a reward.',
  text26: 'Continue ->',
  text221333: 'send us an email',
  text16: '07',
  imageAlt41: 'image',
  name61: 'Enjoy flexibility in how you contribute',
  imageSrc121121: '/assets/asset%2028-200w.png',
  imageSrc141: '/frames/frame_shape2.svg',
  imageAlt91: 'image',
  imageSrc1121: '/assets/ig_blue%20copy%202-200h.png',
  imageAlt111: 'image',
  text111:
    'This is a way for you to honor the people around you or even celebrate the memory of someone dear to you, or someone who inspired you, with the title of Ambassador.',
  imageAlt1711: 'image',
  text7: ' ',
  imageSrc9111: '/frames/frame_shape2.svg',
  imageAlt1241: 'image',
  text191:
    'When donating as a company or non-profit, please keep in mind that the title of Ambassador along with benefits can only be given to yourself or the people you choose and cannot be attributed to said company or non-profit.',
  text37: 'Contribute\xA0',
  imageSrc41: '/formula/roi_blue2.svg',
  text21: '06',
  imageSrc91: '/frames/frame_shape2.svg',
  text110: "I've decided ->",
  name4: 'Ambassadors are the driving force for growth',
  text201: 'Continue ->',
  imageAlt1721: 'image',
  text2: '07',
  imageAlt131: 'image',
  text24: '07',
  imageAlt101: 'image',
  text31: 'Signed Certificate of Merit',
  imageSrc131: '/external/roi_blue.svg',
  text1: '01',
  text5: '07',
  imageAlt12121: 'image',
  section51: 'Ambassadors Program',
  imageAlt12111: 'image',
  caption211111:
    'See how your financial contribution creates value for Romania, here.',
  section21: 'Ambassadors Program',
  imageAlt161: 'image',
  text39: ' to become an Ambassador or gift the title to others',
  text33: 'Continue reading',
  section11: 'Ambassadors Program',
  imageSrc1811: '/frames/corner_arrow.svg',
  text91: 'Continue ->',
  text221:
    "We are happy to accommodate alternative donation methods according to your preference. Send us an email and we'll get it sorted.",
  text101:
    'Choose yourself, friends, family or colleagues or commemorate others by making them Ambassadors',
  imageSrc51: '/formula/roi_blue2.svg',
  imageAlt21: 'image',
  text221322: 'hi@romania.org.ro',
  text12111:
    'Donating for others means they become Ambassadors and they receive all the benefits associated.',
  imageSrc17211: '/frames/corner.svg',
  imageSrc101: '7892b4be-faf3-4ba2-92ac-e5943305ddd3',
  section1: 'Ambassadors Program',
  text25: 'Continue',
  text15: '04',
  caption21:
    'We believe that helping build Romania’s Country Brand deserves to be recognized. Join the ranks of pioneers for driving positive change in Romania and be rewarded for your invaluable contribution with equally precious distinction.',
  imageSrc17221: '/frames/corner.svg',
  imageSrc1721: '/frames/corner.svg',
  title1: "for everything you've done for Romania",
  imageSrc11: '/formula/roi_blue2.svg',
  text10: 'See how your financial contribution creates value for Romania, ',
  imageSrc121: '/assets/asset%2030-200w.png',
  imageSrc1: '/brush1-200h.png',
  text211: 'Donate via bank transfer or other preferred methods',
  name21: 'Create positive change as an Ambassador',
  text2213321: 'text us on instagram',
  imageSrc11221: '/assets/ig_blue%20copy%203-200w.png',
  rootClassName: '',
}

Flowambassador.propTypes = {
  imageAlt141: PropTypes.string,
  imageSrc17121: PropTypes.string,
  imageAlt912: PropTypes.string,
  imageSrc1821: PropTypes.string,
  section7: PropTypes.string,
  text17: PropTypes.string,
  text2211: PropTypes.string,
  text3: PropTypes.string,
  imageSrc1712: PropTypes.string,
  caption21112: PropTypes.string,
  text122: PropTypes.string,
  section31: PropTypes.string,
  name31: PropTypes.string,
  name11: PropTypes.string,
  imageAlt111121: PropTypes.string,
  text12: PropTypes.string,
  imageSrc111: PropTypes.string,
  imageAlt14: PropTypes.string,
  section61: PropTypes.string,
  imageAlt51: PropTypes.string,
  imageSrc61: PropTypes.string,
  text14: PropTypes.string,
  imageSrc81: PropTypes.string,
  imageAlt10221: PropTypes.string,
  imageSrc912: PropTypes.string,
  text6: PropTypes.string,
  imageAlt9111: PropTypes.string,
  imageAlt71: PropTypes.string,
  text8: PropTypes.string,
  text19: PropTypes.string,
  imageSrc161: PropTypes.string,
  text221321: PropTypes.string,
  text23: PropTypes.string,
  text9: PropTypes.string,
  text: PropTypes.string,
  text51: PropTypes.string,
  imageSrc21: PropTypes.string,
  text231: PropTypes.string,
  text18: PropTypes.string,
  imageAlt151: PropTypes.string,
  imageAlt15: PropTypes.string,
  imageAlt61: PropTypes.string,
  text221331: PropTypes.string,
  text41: PropTypes.string,
  imageSrc171: PropTypes.string,
  imageAlt125: PropTypes.string,
  imageSrc1731: PropTypes.string,
  text71: PropTypes.string,
  imageAlt1213: PropTypes.string,
  text3221: PropTypes.string,
  imageAlt1021: PropTypes.string,
  imageSrc182: PropTypes.string,
  name51: PropTypes.string,
  imageAlt1223: PropTypes.string,
  imageSrc71: PropTypes.string,
  imageAlt81: PropTypes.string,
  imageAlt173: PropTypes.string,
  text22: PropTypes.string,
  text81: PropTypes.string,
  text4: PropTypes.string,
  text29: PropTypes.string,
  text38: PropTypes.string,
  imageSrc1741: PropTypes.string,
  imageAlt31: PropTypes.string,
  imageSrc151: PropTypes.string,
  imageSrc31: PropTypes.string,
  name71: PropTypes.string,
  imageAlt12211: PropTypes.string,
  text20: PropTypes.string,
  caption3: PropTypes.string,
  text61: PropTypes.string,
  text2111: PropTypes.string,
  imageAlt12221: PropTypes.string,
  imageAlt1231: PropTypes.string,
  text13: PropTypes.string,
  imageSrc17111: PropTypes.string,
  caption11: PropTypes.string,
  text26: PropTypes.string,
  text221333: PropTypes.string,
  text16: PropTypes.string,
  imageAlt41: PropTypes.string,
  name61: PropTypes.string,
  imageSrc121121: PropTypes.string,
  imageSrc141: PropTypes.string,
  imageAlt91: PropTypes.string,
  imageSrc1121: PropTypes.string,
  imageAlt111: PropTypes.string,
  text111: PropTypes.string,
  imageAlt1711: PropTypes.string,
  text7: PropTypes.string,
  imageSrc9111: PropTypes.string,
  imageAlt1241: PropTypes.string,
  text191: PropTypes.string,
  text37: PropTypes.string,
  imageSrc41: PropTypes.string,
  text21: PropTypes.string,
  imageSrc91: PropTypes.string,
  text110: PropTypes.string,
  name4: PropTypes.string,
  text201: PropTypes.string,
  imageAlt1721: PropTypes.string,
  text2: PropTypes.string,
  imageAlt131: PropTypes.string,
  text24: PropTypes.string,
  imageAlt101: PropTypes.string,
  text31: PropTypes.string,
  imageSrc131: PropTypes.string,
  text1: PropTypes.string,
  text5: PropTypes.string,
  imageAlt12121: PropTypes.string,
  section51: PropTypes.string,
  imageAlt12111: PropTypes.string,
  caption211111: PropTypes.string,
  section21: PropTypes.string,
  imageAlt161: PropTypes.string,
  text39: PropTypes.string,
  text33: PropTypes.string,
  section11: PropTypes.string,
  imageSrc1811: PropTypes.string,
  text91: PropTypes.string,
  text221: PropTypes.string,
  text101: PropTypes.string,
  imageSrc51: PropTypes.string,
  imageAlt21: PropTypes.string,
  text221322: PropTypes.string,
  text12111: PropTypes.string,
  imageSrc17211: PropTypes.string,
  imageSrc101: PropTypes.string,
  section1: PropTypes.string,
  text25: PropTypes.string,
  text15: PropTypes.string,
  caption21: PropTypes.string,
  imageSrc17221: PropTypes.string,
  imageSrc1721: PropTypes.string,
  title1: PropTypes.string,
  imageSrc11: PropTypes.string,
  text10: PropTypes.string,
  imageSrc121: PropTypes.string,
  imageSrc1: PropTypes.string,
  text211: PropTypes.string,
  name21: PropTypes.string,
  text2213321: PropTypes.string,
  imageSrc11221: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default Flowambassador
